// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"87da5422","237":"e87e5526","367":"8c25a1e2","411":"d5d6cc4d","480":"45d120af","744":"e7fdcf26","801":"cfcf4095","866":"ed002834"}[chunkId] + ".chunk.js";
};